const DISCORD_AVATAR_PATTERN = /^https:\/\/cdn\.discordapp\.com\/(?:avatars\/[0-9]{17,20}\/(?:a_)?[0-9a-f]{32}\.(?:png|webp)(?:\?size=(?:64|128|256|512))?|embed\/avatars\/[0-5]\.png)$/;

function fixedAvatar(id, fallbackLabel) {
  return Object.freeze({
    id,
    value: `/img/icons.svg#fishy-${id}-fill`,
    labelKey: `account.avatar.${id}`,
    fallbackLabel,
  });
}

export const FIXED_ACCOUNT_AVATARS = Object.freeze([
  fixedAvatar("fish", "Fish"),
  fixedAvatar("cat", "Cat"),
  fixedAvatar("dog", "Dog"),
  fixedAvatar("rabbit", "Rabbit"),
  fixedAvatar("bear", "Bear"),
  fixedAvatar("deer", "Deer"),
  fixedAvatar("bird", "Bird"),
  fixedAvatar("butterfly", "Butterfly"),
  fixedAvatar("flower", "Flower"),
  fixedAvatar("leaf", "Leaf"),
  fixedAvatar("tree", "Tree"),
  fixedAvatar("wave", "Wave"),
  fixedAvatar("paw", "Paw"),
  fixedAvatar("birthday-2", "Birthday cake"),
  fixedAvatar("bone", "Bone"),
  fixedAvatar("bottle-glass", "Glass bottle"),
  fixedAvatar("bowl-2", "Bowl 2"),
  fixedAvatar("bowl", "Bowl"),
  fixedAvatar("bread", "Bread"),
  fixedAvatar("cake", "Cake"),
  fixedAvatar("candy-2", "Candy 2"),
  fixedAvatar("candy", "Candy"),
  fixedAvatar("carrot", "Carrot"),
  fixedAvatar("champagne", "Champagne"),
  fixedAvatar("chicken", "Chicken"),
  fixedAvatar("chopsticks", "Chopsticks"),
  fixedAvatar("cookie", "Cookie"),
  fixedAvatar("cookie-man", "Gingerbread person"),
  fixedAvatar("cupcake", "Cupcake"),
  fixedAvatar("dinner", "Dinner"),
  fixedAvatar("dish-cover", "Serving dish"),
  fixedAvatar("donut", "Donut"),
  fixedAvatar("drink", "Drink"),
  fixedAvatar("egg-crack", "Cracked egg"),
  fixedAvatar("egg", "Egg"),
  fixedAvatar("electric-cooker", "Rice cooker"),
  fixedAvatar("feeder", "Feeder"),
  fixedAvatar("fork", "Fork"),
  fixedAvatar("fork-knife", "Fork and knife"),
  fixedAvatar("fork-spoon", "Fork and spoon"),
  fixedAvatar("fried-egg", "Fried egg"),
  fixedAvatar("fries", "Fries"),
  fixedAvatar("glass-cup", "Glass cup"),
  fixedAvatar("hamburger", "Hamburger"),
  fixedAvatar("ice-cream-2", "Ice cream 2"),
  fixedAvatar("ice-cream", "Ice cream"),
  fixedAvatar("lollipop", "Lollipop"),
  fixedAvatar("pizza", "Pizza"),
  fixedAvatar("soup-pot-2", "Soup pot 2"),
  fixedAvatar("soup-pot", "Soup pot"),
  fixedAvatar("spatula", "Spatula"),
  fixedAvatar("spoon", "Spoon"),
  fixedAvatar("sugar-coated-haws", "Candied haws"),
  fixedAvatar("teacup", "Teacup"),
  fixedAvatar("wine", "Wine"),
  fixedAvatar("wineglass-2", "Wine glass 2"),
  fixedAvatar("wineglass", "Wine glass"),
]);

const FIXED_AVATAR_VALUES = new Set(FIXED_ACCOUNT_AVATARS.map(({ value }) => value));

export const ACCOUNT_AVATAR_COLORS = Object.freeze([
  Object.freeze({
    value: "base",
    labelKey: "account.avatar.color.base",
    fallbackLabel: "Theme",
  }),
  Object.freeze({
    value: "primary",
    labelKey: "account.avatar.color.primary",
    fallbackLabel: "Primary",
  }),
  Object.freeze({
    value: "secondary",
    labelKey: "account.avatar.color.secondary",
    fallbackLabel: "Secondary",
  }),
  Object.freeze({
    value: "accent",
    labelKey: "account.avatar.color.accent",
    fallbackLabel: "Accent",
  }),
]);

const ACCOUNT_AVATAR_COLOR_VALUES = new Set(
  ACCOUNT_AVATAR_COLORS.map(({ value }) => value),
);

export function isDiscordAvatarReference(value) {
  return typeof value === "string" && DISCORD_AVATAR_PATTERN.test(value);
}

export function isFixedAvatarReference(value) {
  return typeof value === "string" && FIXED_AVATAR_VALUES.has(value);
}

export function isAccountAvatarReference(value) {
  return isFixedAvatarReference(value) || isDiscordAvatarReference(value);
}

export function decodeAccountAvatarReference(value, label = "Account avatar") {
  if (value === undefined || value === "") {
    return "";
  }
  if (typeof value !== "string" || value.length > 512 || !isAccountAvatarReference(value)) {
    throw new TypeError(`${label} is invalid`);
  }
  return value;
}

export function decodeDiscordAvatarUrl(value, label = "Discord avatar") {
  if (value === undefined || value === "") return "";
  if (typeof value !== "string" || value.length > 512 || !isDiscordAvatarReference(value)) {
    throw new TypeError(`${label} is invalid`);
  }
  return value;
}

export function decodeAccountAvatarColor(value, label = "Account avatar color") {
  if (value === undefined || value === "") return "base";
  if (typeof value !== "string" || !ACCOUNT_AVATAR_COLOR_VALUES.has(value)) {
    throw new TypeError(`${label} is invalid`);
  }
  return value;
}
